import BaseService from '@/services/BaseService'
import { http } from './config'
import moment from 'moment'
class ContaPagarService extends BaseService {
    constructor() {
        
        super('/v1/contas-pagar')
    }

    listar(data){
        return http.get(`/v1/contas-pagar`, {params: data})
    }

    listarPorPeriodo(data) {
        return http.get(`/v1/contas-pagar?periodo_inicial=${data.periodo_inicial}&periodo_final=${data.periodo_final}&content=${data.content}&situacao=${data.situacao}`)
    }

    baixar(id){
        return http.put(`/v1/contas-pagar/${id}`, {
            situacao: 'PAGO',
            data_pagamento: moment().format('YYYY-MM-DD')
        })
    }

    atualizar(data) {
        const id = data.get('id')
        return http.post(`/v1/contas-pagar/${id}`, data)
    }
}

export default new ContaPagarService